import fetchJsonp from 'fetch-jsonp'

const APPLE_PODCAST_ID = '1813645485'
const APPLE_LOOKUP_URL = 'https://itunes.apple.com/lookup'

/**
 * Fetches podcast episodes from Apple Podcasts API using JSONP to bypass CORS.
 * This API is free and doesn't require authentication.
 */
export async function fetchPodcastEpisodes() {
  try {
    const url = `${APPLE_LOOKUP_URL}?id=${APPLE_PODCAST_ID}&entity=podcastEpisode&limit=100&sort=recent`
    
    // JSONP request
    const response = await fetchJsonp(url)
    const data = await response.json()
    const { results } = data

    if (!results || results.length === 0) {
      return []
    }

    // First result is the podcast info, rest are episodes
    const [podcastInfo, ...episodes] = results

    // Transform and return episodes
    return episodes.map((episode) => ({
      id: episode.trackId,
      title: episode.trackName,
      description: episode.description || episode.shortDescription,
      releaseDate: episode.releaseDate,
      trackTimeMillis: episode.trackTimeMillis,
      artworkUrl600: episode.artworkUrl600 || podcastInfo.artworkUrl600,
      episodeUrl: episode.episodeUrl,
      collectionViewUrl: episode.collectionViewUrl,
      trackId: episode.trackId,
      episodeNumber: episode.trackNumber,
    }))
  } catch (error) {
    console.error('Error fetching podcast episodes:', error)
    throw error // Propagate error to let UI handle it
  }
}

/**
 * Fetches a single episode by ID
 */
export async function fetchEpisodeById(episodeId) {
  try {
    const url = `${APPLE_LOOKUP_URL}?id=${episodeId}`
    
    const response = await fetchJsonp(url)
    const data = await response.json()
    const { results } = data

    if (!results || results.length === 0) {
      return null
    }

    const episode = results[0]

    return {
      id: episode.trackId,
      title: episode.trackName,
      description: episode.description,
      releaseDate: episode.releaseDate,
      trackTimeMillis: episode.trackTimeMillis,
      artworkUrl600: episode.artworkUrl600,
      episodeUrl: episode.episodeUrl,
      collectionViewUrl: episode.collectionViewUrl,
      trackId: episode.trackId,
    }
  } catch (error) {
    console.error('Error fetching episode:', error)
    return null
  }
}

/**
 * Gets the podcast metadata
 */
export async function fetchPodcastInfo() {
  try {
    const url = `${APPLE_LOOKUP_URL}?id=${APPLE_PODCAST_ID}`
    
    const response = await fetchJsonp(url)
    const data = await response.json()
    const { results } = data

    if (!results || results.length === 0) {
      return null
    }

    const podcast = results[0]

    return {
      id: podcast.collectionId,
      name: podcast.collectionName,
      artistName: podcast.artistName,
      artworkUrl600: podcast.artworkUrl600,
      feedUrl: podcast.feedUrl,
      collectionViewUrl: podcast.collectionViewUrl,
      trackCount: podcast.trackCount,
      genres: podcast.genres,
    }
  } catch (error) {
    console.error('Error fetching podcast info:', error)
    return null
  }
}
